module.exports = __webpack_public_path__ + "img/info.62067f89.svg";